import actions from '../action/item'
import CONSTANT from '../constant/item'
import _ from 'underscore'
import {
  Toast,
} from 'mint-ui'
import {
  getCitysByIds,
  getDistanceBetween2,
  sliceGroup,
  goodsListFormat,
} from '../util/function'

const itemList = []
const itemDetailList = []
const itemDescList = []
const itemAttrList = []

const itemAttrsInfo = {}
const defaultStoreList = {
  list: [],
  page: {
    total: 0,
  },
}

export default {
  actions,
  state: {
    itemList,
    itemDetailList,
    itemDescList,
    itemAttrList,
    currentItem: {},
    selectedOption: [],
    selectedItem: [],
    magnify: false,
    picList: [],
    storeSelectedSku: {}, // 把选择中的sku储存
    applicableCity: [],


    itemAttrsInfo,
    storeList: defaultStoreList,
    storeDetail: {},

    isProductNotExist: false,

    // 现金券
    suitableCouponLabelList: [],
    suitableCouponList: [],

    // 推荐商品
    commondProductList: [],
    lookProductList: [],

  },
  mutations: {
    [CONSTANT.ITEM_GET_PRODUCT_ATTRS_SUCCESS](state, info) {
      return state.itemAttrsInfo = info
    },
    [CONSTANT.ITEM_GET_PRODUCT_ATTRS_ERROR](state, e) {
      return state.itemAttrsInfo = {}
    },

    [CONSTANT.ITEM_GET_LIST_SUCCESS](state, list) {
      return state.itemList = state.itemList.concat(list || [])
    },
    [CONSTANT.ITEM_GET_LIST_ERROR](state, e) {
      return state.itemList = []
    },
    [CONSTANT.ITEM_GET_LIST_ERROR_EMPTY](state, e) {
      return state.itemList = []
    },
    [CONSTANT.ITEM_GET_DETAIL_SUCCESS](state, item) {
      state.isProductNotExist = false
      state.currentItem = item
      return state.itemDetailList.push(item)
    },
    [CONSTANT.ITEM_GET_DETAIL_ERROR](state, e) {

    },
    [CONSTANT.ITEM_GET_DETAIL_ERROR_EMPTY](state, e) {

    },
    [CONSTANT.ITEM_GET_DETAIL_NO_PRODUCT](state, value) {
      state.isProductNotExist = true
    },
    [CONSTANT.ITEM_GET_ATTR_SUCCESS](state, res) {
      return state.itemAttrList.push(res)
    },
    [CONSTANT.ITEM_GET_ATTR_ERROR](state, e) {

    },
    [CONSTANT.ITEM_GET_ATTR_ERROR_EMPTY](state, e) {

    },
    [CONSTANT.ITEM_GET_DESC_SUCCESS](state, res) {
      return state.itemDescList.push(res)
    },
    [CONSTANT.ITEM_GET_DESC_ERROR](state, e) {

    },
    [CONSTANT.ITEM_GET_DESC_ERROR_EMPTY](state, e) {

    },
    [CONSTANT.ITEM_MAGNIFY_SHOW](state, list) {
      state.picList = list
      return state.magnify = true
    },
    [CONSTANT.ITEM_MAGNIFY_HIDE](state, list) {
      return state.magnify = false
    },
    [CONSTANT.ITEM_SELECTED_SKU_STORE](state, sku) {
      return state.storeSelectedSku = sku
    },
    [CONSTANT.ITEM_GETPRODUCTCITYLIST_SUCCESS](state, data) {
      return state.applicableCity = getCitysByIds(data)
    },
    [CONSTANT.ITEM_GETPRODUCTCITYLIST_ERROR](state, e) {
      Toast({
        message: e,
        position: 'bottom',
        duration: 3000,
      })
    },
    [CONSTANT.ITEM_CHECKDELIVERY_SUCCESS](state, data) {

    },
    [CONSTANT.ITEM_CHECKDELIVERY_ERROR](state, e) {
      // Toast({
      //   message: e,
      //   position: 'bottom',
      //   duration: 3000
      // })
    },
    [CONSTANT.ITEM_QUERYAREAINFOBYIDS_SUCCESS](state, data) {

    },
    [CONSTANT.ITEM_QUERYAREAINFOBYIDS_ERROR](state, e) {
      Toast({
        message: e,
        position: 'bottom',
        duration: 3000,
      })
    },
    [CONSTANT.ITEM_GET_STORE_LIST_SUCCESS](state, data) {
      // 按距离排序
      const position = this.getters.getGPSPostion
      const list = _.chain(data.list).map((item, index) => {
        const distance = getDistanceBetween2(
          `${item.la}:${item.lo}`,
          `${position.latitude}:${position.longitude}`,
        );
        return { ...item, distance }
      })
        .sortBy(item => parseFloat(item.distance))
        .value()
      state.storeList = { ...data, list }
      state.storeDetail = list.length ? list[0] : {}
    },
    [CONSTANT.ITEM_GET_STORE_LIST_ERROR](state, data) {
      state.storeList = defaultStoreList
    },
    [CONSTANT.ITEM_GET_STORE_DETAIL_SUCCESS](state, data) {
      state.storeDetail = data
    },
    [CONSTANT.ITEM_GET_STORE_DETAIL_ERROR](state, data) {
      state.storeDetail = {}
    },
    [CONSTANT.ITEM_GET_SUITABLE_COUPON_SUCCESS](state, data) {
      state.suitableCouponLabelList = [...data.labels]
      state.suitableCouponList = [...data.coupons]
    },
    [CONSTANT.ITEM_GET_SUITABLE_COUPON_ERROR](state, data) {
      state.suitableCouponLabelList = []
      state.suitableCouponList = []
    },
    [CONSTANT.ITEM_SET_SUITABLE_COUPON_SUCCESS](state, data) {
      // 不刷新页面改变领取状态
      const { code } = data
      const tempArr = [...state.suitableCouponList]
      _.each(tempArr, (v, i) => {
        if (v.code === code) {
          v.status = 2
        }
      })
      state.suitableCouponList = [...tempArr]
    },
    [CONSTANT.ITEM_SET_SUITABLE_COUPON_ERROR](state, data) {

    },
    // 为你推荐商品整合
    [CONSTANT.ITEM_GET_RELATED_PRODUCT_SUCCESS](state, data) {
      if (_.isEmpty(data)) {
        return []
      }
      const tempArr = goodsListFormat(data.list)
      const length = tempArr.length
      if (length <= 6) {
        state.commondProductList = sliceGroup(tempArr, 6)
      } else if (length > 6) {
        state.commondProductList = sliceGroup(tempArr, 6)
      } else {
        return []
      }
    },
    [CONSTANT.ITEM_GET_RELATED_PRODUCT_ERROR](state, data) {
      state.commondProductList = []
    },
    // 看了又看商品整合
    [CONSTANT.ITEM_GET_LOOK_RELATED_PRODUCT_SUCCESS](state, data) {
      let tempArr
      if (!_.isEmpty(data)) {
        tempArr = goodsListFormat(data.list)
      }
      state.lookProductList = [...state.lookProductList, ...tempArr]
    },
    [CONSTANT.ITEM_GET_LOOK_RELATED_PRODUCT_ERROR](state, data) {
      state.lookProductList = []
    },


    /*yeoman-template-point-1*/
  },
  getters: {
    getOptions(state, getters, rootState) {


    },
  },
}
